import type { ProcessTimerTranslations } from './processTimer.translation.pl.ts';

export const processTimerTranslations: ProcessTimerTranslations = {
  calculating: 'Calcul en cours...',
  heartBeatError:
    "Une erreur de connexion s'est produite. Tes résultats ont été enregistrés. La page va s'actualiser dans un instant.",
};
